import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { DataProvider } from "./context/Data.context";
import { AlertProvider, ConfirmProvider } from "@moreirapontocom/npmhelpers";

import Welcome from "./views/Welcome/Welcome";
import FirstRun from "./views/FirstRun/FirstRun";
import CreateProfile from "./views/CreateProfile/CreateProfile";
import ListProfiles from "./views/ListProfiles/ListProfiles";
import Home from "./views/Home/Home";
import NewTest from "./views/NewTest/NewTest";
import PairReader from "./views/PairReader/PairReader";
import ListReaders from "./views/ListReaders/ListReaders";
import ReaderDetails from "./views/ReaderDetails/ReaderDetails";
import Bluetooth from "./views/Bluetooth/Bluetooth";
import Help from "./views/Help/Help";
import About from "./views/About/About";
import TestResult from "./views/TestResult/TestResult";

import "./index.scss";

const appVersion: string = process.env.REACT_APP_VERSION || "";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register(`service-worker.js?version=${appVersion}`).then((registration: any) => {
    console.log("Service worker version:", appVersion);
    console.log("Service worker registration succeeded:", registration);
  }).catch((error: any) => {
    console.error(`Service worker registration failed: ${error}`);
  });
} else {
  console.error("Service workers are not supported.");
}

const routes: any = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/welcome",
        element: <Welcome />,
      },
      {
        path: "/firstRun",
        element: <FirstRun />,
      },
      {
        path: "/createProfile",
        element: <CreateProfile />,
      },
      {
        path: "/pairReader",
        element: <PairReader />,
      },
      {
        path: "/listProfiles",
        element: <ListProfiles />,
      },
      {
        path: "/readers",
        element: <ListReaders />,
      },
      {
        path: "/readers/:readerHashId",
        element: <ReaderDetails />,
      },
      {
        path: "/result/:resultHash",
        element: <TestResult />,
      },
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/newTest",
        element: <NewTest />,
      },
      {
        path: "/help",
        element: <Help />,
      },
      {
        path: "/about",
        element: <About />,
      },

      // TEMPORARY PAGE. REMOVE IT LATER
      {
        path: "/temp",
        element: <Bluetooth />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <DataProvider>
      <ConfirmProvider>
        <AlertProvider>
          <RouterProvider router={routes} />
        </AlertProvider>
      </ConfirmProvider>
    </DataProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
